import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import { IoMdArrowBack } from "react-icons/io";
import IsolationPermitTemplate from "../IsolationWorkPermit/IsolationPermitTemplate";
import "./IsolationTemplate1.css";
import { fetchIsolationPermit } from "./isolationPermitApi";

function IsolationTemplate() {
  const navigate = useNavigate();
  const { permitId } = useParams();
  const [loading, setLoading] = useState(Boolean(permitId));
  const [permitPayload, setPermitPayload] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = useCallback((message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  }, []);

  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const loadPermit = useCallback(async () => {
    if (!permitId) return;

    try {
      setLoading(true);
      const response = await fetchIsolationPermit(permitId);
      setPermitPayload(response);
    } catch (error) {
      showSnackbar(
        error?.response?.data?.message || "Failed to load generated permit",
        "error",
      );
    } finally {
      setLoading(false);
    }
  }, [permitId, showSnackbar]);

  useEffect(() => {
    loadPermit();
  }, [loadPermit]);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <div>Loading generated isolation permit...</div>
      </div>
    );
  }

  if (!permitId || !permitPayload?.permit) {
    return (
      <>
        <div className="isolation-permit" style={{ padding: "40px 20px" }}>
          <div className="data-form-heading-content-left-side">
            <Tooltip title="Back" arrow>
              <IoMdArrowBack className="back-company" onClick={() => navigate(-1)} />
            </Tooltip>
            Generated permit not found
          </div>
        </div>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          style={{ marginTop: "35px", marginLeft: "20px" }}
        >
          <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>
      </>
    );
  }

  return (
    <>
      <div className="isolation-permit">
        <div
          className="data-form-heading-content-left-side"
          style={{ justifyContent: "center", marginBottom: "12px" }}
        >
          <Tooltip title="Back" arrow>
            <IoMdArrowBack className="back-company" onClick={() => navigate(-1)} />
          </Tooltip>
          Generated Isolation Permit
        </div>
        <div className="isolation-permit-pdf">
          <IsolationPermitTemplate permitDetails={permitPayload} />
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default IsolationTemplate;
